import { HomepageElement } from '../homepage'
import { allTimeRanges } from '../widget-points-leaderboard/indexWidget.sync'
import { TypesThatCanBeAdded } from './new-button'
import { Tab } from '../homepage-tabs/TabsConfigurator'
import { TextAlignment } from '../widget-banner/configurator'

export const getDefaultWidget = (type: TypesThatCanBeAdded, id: number): HomepageElement => {
  const sharedDefault = {
    active: true,
    id
  }
  switch (type) {
    case 'banner':
      return {
        ...sharedDefault,
        type,
        title: 'Banner',
        config: {
          content: {
            textAlignment: 'Center' as TextAlignment,
            title: '',
            description: ''
          },
          buttons: {
            primaryText: '',
            primaryUrl: '',
            secondaryText: '',
            secondaryUrl: ''
          }
        }
      }
    case 'html_widget':
      return {
        ...sharedDefault,
        type,
        title: '',
        config: {
          html: ''
        }
      }
    case 'badges':
      return {
        ...sharedDefault,
        type,
        title: 'Badges',
        config: {
          amount: 5
        }
      }
    case 'tag_cloud':
      return {
        ...sharedDefault,
        type,
        title: 'Popular tags',
        config: {
          amount: 5
        }
      }
    case 'leaderboard_points':
      return {
        ...sharedDefault,
        type,
        title: 'User leaderboard',
        config: {
          maxResults: 5,
          excludeUserRole: [],
          timeRange: allTimeRanges,
          emptyMessage: '',
          isPreviewEmptyMessage: false,
          showLink: false,
          linkText: 'Show full leaderboard',
          showLoggedInUserSection: true
        }
      }
    case 'event_calendar':
      return {
        ...sharedDefault,
        type,
        title: 'Events Calendar',
        config: {
          amount: 5
        }
      }
    case 'solved_topics':
      return {
        ...sharedDefault,
        type,
        title: 'Solved topics',
        config: {
          amount: 5
        }
      }
    case 'most_liked':
      return {
        ...sharedDefault,
        type,
        title: 'Most Liked',
        config: {
          amount: 5,
          period: 7
        }
      }
    case 'community_statistics':
      return {
        ...sharedDefault,
        type,
        title: 'Community Statistics',
        config: {
          total_topics: true,
          total_comments: true,
          total_users: true
        }
      }
    case 'quick_links':
      return {
        ...sharedDefault,
        type,
        title: 'Quick links',
        config: {
          borderRadius: 3,
          enableBorder: true,
          quickLinks: []
        }
      }
    case 'recommendations':
      return {
        ...sharedDefault,
        type,
        title: 'Recommendations',
        config: {
          curatedTopics: []
        }
      }
    case 'featured_topics':
      return {
        ...sharedDefault,
        type,
        title: 'Featured Topics',
        config: {
          topics: [],
          firstTopicsNumber: 1,
          buttonLabel: '',
          buttonURL: '',
          subtitle: '',
          backgroundColor: ''
        }
      }
    case 'feature_topics':
      return {
        ...sharedDefault,
        type,
        config: {}
      }
    case 'category_and_topics_stream_only':
      // eslint-disable-next-line no-case-declarations
      const tabs: Tab[] = [{
        phrase_suffix: 'categories',
        enabled: true,
        class: '_index-forums',
        collapsed: true,
        phrase: 'Categories'
      }, {
        phrase_suffix: 'unanswered',
        enabled: true,
        class: 'branded/_index-unanswered-topics',
        collapsed: false,
        phrase: 'Help others'
      }, {
        phrase_suffix: 'recent_active',
        enabled: true,
        class: 'branded/_index-recent-topics',
        collapsed: false,
        phrase: 'Recently active'
      }]
      return {
        ...sharedDefault,
        type,
        title: '',
        config: {
          tabs: tabs
        }
      }
    case 'container_2_1':
      return {
        ...sharedDefault,
        type,
        title: 'Container 2:1',
        config: {
          column_1: [],
          column_2: []
        }
      }
    case 'announcement_card':
      return {
        ...sharedDefault,
        type,
        title: 'Announcement Card',
        config: {}
      }
    case 'introduction_bar':
      return {
        ...sharedDefault,
        type,
        title: '',
        nonConfigurable: true,
        config: {}
      }
    case 'statistics_bar':
      return {
        ...sharedDefault,
        type,
        title: '',
        nonConfigurable: true,
        config: {}
      }
    case 'ideation_statistics_bar':
      return {
        ...sharedDefault,
        type,
        title: '',
        nonConfigurable: true,
        config: {}
      }
    case 'hero_banner':
      return {
        ...sharedDefault,
        type,
        title: '',
        config: {
          heroImage: '',
          headline: ''
        }
      }
    case 'knowledge_base':
      return {
        ...sharedDefault,
        type,
        title: 'Knowledge Base',
        config: {
          selectedTemplate: 0,
          displayOnlyParent: true
        }
      }
    case 'community_category':
      return {
        ...sharedDefault,
        type,
        title: 'Community Categories',
        config: {
          selectedTemplate: 0,
          displayOnlyParent: true
        }
      }
    case 'groups':
      return {
        ...sharedDefault,
        type,
        title: 'Top groups',
        config: {
          groups: [],
          buttonLabel: '',
          buttonURL: ''
        }
      }
    case 'ideation_pipeline':
      return {
        ...sharedDefault,
        type,
        title: 'Idea pipeline',
        config: {
          column_1: 0,
          column_2: 0,
          column_3: 0,
          maxHeight: 480
        }
      }
    case 'ideation_hero':
      return {
        ...sharedDefault,
        type,
        title: 'Hero banner',
        config: {
          heroImage: '',
          title: '',
          tagline: ''
        }
      }
    case 'ideation_list':
      return {
        ...sharedDefault,
        type,
        nonConfigurable: true,
        title: '',
        config: {}
      }
    case 'ideation_status_filter':
      return {
        ...sharedDefault,
        type,
        nonConfigurable: true,
        title: 'Filter by idea status',
        config: {}
      }
    case 'product_area_filter':
      return {
        ...sharedDefault,
        type,
        nonConfigurable: true,
        title: 'Filter by product area',
        config: {}
      }
    case 'header_navigation':
      return {
        ...sharedDefault,
        type,
        title: 'Mega menu',
        config: {
          logo: '',
          items: []
        }
      }

    case 'product-updates_hero':
      return {
        ...sharedDefault,
        type,
        title: 'Hero banner',
        config: {
          heroImage: '',
          title: '',
          tagline: ''
        }
      }
    case 'generic_hero':
      return {
        ...sharedDefault,
        type,
        title: 'Hero banner',
        config: {
          heroImage: '',
          title: '',
          tagline: ''
        }
      }
  }
}
